import React, { useEffect, useState } from "react";
import pako from "pako";
import {
  decompressjsondata,
  getFormattedDate,
} from "../../../../actions/common";
import moment from "moment";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { PiUserSwitch } from "react-icons/pi";
import Whisper from "rsuite/esm/Whisper";
import Tooltip from "rsuite/esm/Tooltip";

const ProductModal = ({
  product,
  productKey,
  customerDetails,
  setShowExtendedTrialModal,
  setExtendedTrialData,
  handleAccountSwitch,
  ismuvi5
}) => {

  const productName = product.product_name;
  const muvi_one = "3D28C83C85544F0D9517DD2E7C7EEDAA";
  const serverId = 1;

  const location = useLocation();
  const [billingDetails, setBillingDetails] = useState({});
  const [applications, setApplications] = useState([]);
  const [getBillingApi, setGetBillingApi] = useState(0);
  const [isCardLoading, setIsCardLoading] = useState(false);
  const [cardsList, setCardsList] = useState([]);
  const [contentAnalytics, setContentAnalytics] = useState({});
  const [getContentApi, setGetContentApi] = useState(0);
  const [bandwidth, setBandwidth] = useState("");
  const [getBandwidthApi, setGetBandwidthApi] = useState(0);
  const [template, setTemplate] = useState("");
  const [getTemplateApi, setGetTemplateApi] = useState(0);
  const [shouldRerender, setShouldRerender] = useState(false);
  const [productData, setProductData] = useState({});

  const billing_period = product.billing_period;

  let startDate = "NA";
  let endDate = "NA";

  if (billing_period && billing_period !== "NA") {
    [startDate, endDate] = billing_period.split(" - ");

    if (endDate) {
      const date = new Date(endDate);
      date.setDate(date.getDate() + 1);

      endDate = date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });
    }
  }


  useEffect(() => {
    if (productKey) {
      // Check if CustomerId is numaric
      // if (
      //   parseInt(customerDetails.customer_id) == customerDetails.customer_id
      // ) {
      //   getMuviFiveBillingDetails();
      // } else {
      if (product.account_status === "Cancelled" && !ismuvi5) {
        getBillingDetails();
      }
      // }
    }
    // if (this.props.account_manager !== this.state.account_manager) {
    //   this.props.getAccountManager(this.state.account_manager);
    // }
    if (shouldRerender) {
      setShouldRerender(false);
    }
  }, [productKey]);

  const isDebug = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.get("debug");
    const debug = queryString == null || queryString == "false" ? false : true;
    return debug;
  };

  const isAPI = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.get("api");
    const isApiCall =
      queryString == null || queryString == "false" ? false : true;
    return isApiCall;
  };

  const getMuviFiveBillingDetails = async () => {
    const externalData = customerDetails.external_data;

    if (!externalData) {
      return;
    }

    const otherBillingDetails = await getMuviFiveOtherBillingDetails();
    const uploadDetails = await getMuviFiveUploadDetails();

    const billingInfo = {
      ...externalData,
      account_status: externalData.customer_type,
      subscribed_plans: {
        platform:
          externalData && externalData.package ? externalData.package : {},
      },
      first_subsription_date: externalData.subscription_start,
      last_transaction_amount: externalData.paid_amount,
      last_transaction_date: externalData.created_date,
      next_subsription_date: externalData.start_date,
      cancellation: {
        canceled_by: externalData.canceled_by,
        reason: externalData.reason,
        date: externalData.start_date_change,
        onhold_period: [
          externalData.start_date_change,
          externalData.end_date_change,
        ],
      },
      deletion: {
        date: externalData.deleted_date,
        deleted_by: externalData.deleted_by,
      },
      is_blocked: externalData.is_blocked,
      revenue_from_user: otherBillingDetails.currency,
      payment_type: otherBillingDetails.payment_method,
      revenue_last_month: otherBillingDetails.revenue_last_month,
    };

    billingInfo.subscribed_plans.platform = {
      ...billingInfo.subscribed_plans.platform,
      interval: externalData.sel_plan,
    };

    const contentAnalytics = {
      ...uploadDetails,
      total_storage_consumption: otherBillingDetails.storage,
    };

    setContentAnalytics(contentAnalytics);

    customerDetails.number_of_login = externalData.total_login;

    const updatedProductData = { ...productData };
    updatedProductData.subadmin_count = otherBillingDetails.subadmin_count;
    updatedProductData.total_no_of_users = otherBillingDetails.enduser_count;
    updatedProductData.total_no_of_subscribed_users =
      otherBillingDetails.total_no_of_subscribed_users;

    setProductData(updatedProductData);

    // setCustomerData((...prev) => ({
    //   ...prev,
    //   number_of_login: externalData.total_login,
    //   subadmin_count: otherBillingDetails.subadmin_count,
    // }));

    // setProductData((...prev) => ({
    //   ...prev,
    //   total_no_of_users: otherBillingDetails.enduser_count,
    //   total_no_of_subscribed_users:
    //     otherBillingDetails.total_no_of_subscribed_users,
    // }));

    setBillingDetails(billingInfo);
    getMuviFiveBandwidthDetails();
  };

  const getMuviFiveOtherBillingDetails = async () => {
    try {
      const debug = isDebug();
      let bodyParams = {
        studio_id: parseInt(customerDetails.customer_id),
        is_live: false,
        server_id: serverId,
        debug,
      };
      const compressedPostData = debug
        ? JSON.stringify(bodyParams)
        : pako.gzip(JSON.stringify(bodyParams));
      const fetchedData = await fetch(
        process.env.REACT_APP_CRM + "/muvi5/other-billing-details",
        {
          method: "POST",
          dataType: "json",
          body: compressedPostData,
        }
      );
      const buffer = debug
        ? await fetchedData.json()
        : await fetchedData.arrayBuffer();

      const findresponse = debug ? buffer : decompressjsondata(buffer);
      const data = {
        package_name: findresponse && findresponse.package_name,
        storage: findresponse && findresponse.storage,
        currency: findresponse && findresponse.currency,
        apiKey: findresponse && findresponse.apiKey,
        apiKeyStatus: findresponse && findresponse.apiKeyStatus,
        subadmin_count: findresponse && findresponse.subadmin_count,
        cards_list: findresponse && findresponse.cards_list,
        payment_method: findresponse && findresponse.payment_method,
        revenue_last_month: findresponse && findresponse.revenue_last_month,
        total_no_of_subscribed_users:
          findresponse && findresponse.total_no_of_subscribed_users,
        enduser_count: findresponse && findresponse.enduser_count,
      };

      return data;
    } catch (error) {
      console.error("Error fetching Muvi Five other billing details:", error);
    }

    return {};
  };

  const getMuviFiveUploadDetails = async () => {
    const debug = isDebug();
    let bodyParams = {
      studio_id: parseInt(customerDetails.customer_id),
      is_live: false,
      server_id: serverId,
      debug,
    };

    try {
      const compressedPostData = debug
        ? JSON.stringify(bodyParams)
        : pako.gzip(JSON.stringify(bodyParams));
      const fetchedData = await fetch(
        process.env.REACT_APP_CRM + "/muvi5/show-upload-details",
        {
          method: "POST",
          dataType: "json",
          body: compressedPostData,
        }
      );
      const buffer = debug
        ? await fetchedData.json()
        : await fetchedData.arrayBuffer();
      const findresponse = debug ? buffer : decompressjsondata(buffer);

      const data = {
        upload_details: findresponse && findresponse.upload_details,
        total_content: findresponse && findresponse.count,
      };

      return data;
    } catch (error) {
      console.error("Error fetching Muvi Five upload details:", error);
    }

    return {};
  };

  const getMuviFiveBandwidthDetails = async () => {
    const debug = isDebug();
    var studioId = parseInt(customerDetails.customer_id);
    const firstdate = moment().startOf("month").format("YYYY-MM-DD");
    let bodyParams = {
      studio_id: studioId,
      created_date: firstdate,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi5/get-bandwidth", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        if (findresponse && findresponse.code == 200) {
          var total_bandwidth = formatBytes(
            findresponse.result[0].total_bandwidth
          );
          setBandwidth(total_bandwidth);
          setGetBandwidthApi(1);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const updateBillingDetails = () => {
    const appToken = customerDetails.customer_id;
    if (!billingDetails || !billingDetails.account_status) {
      return;
    }

    const type = billingDetails.account_status.toLowerCase();

    fetch(
      `${process.env.REACT_APP_CRM}/cron/get-crm-billings?type=${type}&update=3&app_token=${appToken}`
    )
      .then((response) => response.json())
      .then((result) => {
        if (result && result.code === 200) {
          setShouldRerender(true);
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const getCardDetails = () => {
    const userUUID = Cookies.get("muvi_useruuid");
    const debug = isDebug();
    let columnsfetch = {
      app_token: customerDetails.customer_id,
      product_key: productKey,
      user_uuid: userUUID,
      debug,
    };

    if (productKey === "3D28C83C85544F0D9517DD2E7C7EEDAA") {
      columnsfetch = {
        ...columnsfetch,
        user_uuid: userUUID,
        store_key: customerDetails.store_key,
      };
    }
    setIsCardLoading(true);

    console.log("Fetching card details with:", columnsfetch);

    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));

    fetch(process.env.REACT_APP_CRM + "/muvi6/cards", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        if (findresponse && findresponse.code === 200) {
          setCardsList(findresponse.data.cards.cards_list);
          setIsCardLoading(false);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  };

  const getContentDetails = () => {
    const debug = isDebug();
    let columnsfetch = {
      app_token: customerDetails.customer_id,
      product_key: productKey,
      debug,
    };

    if (productKey === "3D28C83C85544F0D9517DD2E7C7EEDAA") {
      columnsfetch = {
        ...columnsfetch,
        store_key: customerDetails.store_key,
      };
    }

    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));
    fetch(process.env.REACT_APP_CRM + "/muvi6/content/content-analytics", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        if (findresponse && findresponse.code === 200) {
          setContentAnalytics(findresponse.data.contentAnalytics);
          setGetContentApi(1);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  };

  const getBandwidthDetails = () => {
    const firstdate = moment().startOf("month").format("YYYY-MM-DD");
    const debug = isDebug();
    let bodyParams = {
      product_key: productKey,
      app_token: customerDetails.customer_id,
      created_date: firstdate,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi6/get-bandwidth", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        if (findresponse && findresponse.code === 200) {
          var total_bandwidth = formatBytes(
            findresponse.result[0].total_bandwidth
          );
          setBandwidth(total_bandwidth);
          setGetBandwidthApi(1);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error.message);
        // Handle fetch error
      });
  };

  const getTemplateDetails = () => {
    if (productKey === muvi_one) {
      const debug = isDebug();
      let columnsfetch = {
        app_token: customerDetails.customer_id,
        debug,
      };
      const compressedPostData = debug
        ? JSON.stringify(columnsfetch)
        : pako.gzip(JSON.stringify(columnsfetch));
      fetch(
        process.env.REACT_APP_CRM + "/muvi6/frontend/get-account-template",
        {
          method: "POST",
          body: compressedPostData,
        }
      )
        .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
        .then((buffer) => {
          const findresponse = debug ? buffer : decompressjsondata(buffer);
          if (findresponse && findresponse.code === 200) {
            setTemplate(findresponse.data.template_name);
            setGetTemplateApi(1);
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error.message);
          // Handle fetch error
        });
    } else {
      setGetTemplateApi(1);
    }
  };

  const getBillingDetails = () => {
    var storeKey = customerDetails.store_key;
    var app_token = customerDetails.customer_id;
    const debug = isDebug();

    let columnsfetch = {
      app_token: app_token,
      product_key: productKey,
      debug,
    };

    if (productKey === "3D28C83C85544F0D9517DD2E7C7EEDAA") {
      columnsfetch = {
        ...columnsfetch,
        store_key: storeKey,
      };
    }

    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));

    console.log("Fetching billing details with:", columnsfetch);

    fetch(process.env.REACT_APP_CRM + "/muvi6/get-billing-details", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        console.log("Billing Response:", findresponse);

        if (findresponse && findresponse.code === 200) {
          setBillingDetails(findresponse.data);
          setApplications(
            findresponse.data.subscribed_plans
              ? findresponse.data.subscribed_plans.applications
              : []
          );
          setGetBillingApi(1);
        } else {
          setBillingDetails({});
          setApplications([]);
        }
      })
      .then(() => {
        if (isAPI()) {
          updateBillingDetails();
        }
      })
      .then(() => {
        getCardDetails();
      })
      .then(() => {
        getContentDetails();
      })
      .then(() => {
        getBandwidthDetails();
      })
      .then(() => {
        getTemplateDetails();
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const getProductNameForImage = () => {
    return productName
      ? productName
        .replaceAll(" ", "+")
        .replaceAll(/%20/g, "+")
        .replaceAll("(", "")
        .replaceAll(")", "")
      : "NA";
  };

  const getLeadSourceFromValue = (value) => {
    switch (value) {
      case "free_trial":
        return "Free Trial";
      case "ask_sales":
        return "Ask Sales";
      case "live_chat":
        return "Live Chat";
      case "manual":
        return "Manual";
      default:
        return "NA";
    }
  };

  const formatBytes = (bytes) => {
    if (!+bytes) return "0.00 B";
    var size = "GB";
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ${size}`;
  };

  const handleExtendedFreeTrialClick = (product) => {
    const data = {
      product_key: productKey || "",
      store_key: customerDetails.store_key || "",
      customer_user_uuid: customerDetails.customer_user_uuid || "",
      app_token: customerDetails.customer_id || "",
      free_trial_expiry_date: product.free_trial_expiry_date,
      company_name: customerDetails.company_name || "",
      mautic_id: customerDetails.mautic_id || "",
      title: "Extend Free Trial",
    };

    setExtendedTrialData((prev) => ({
      ...prev,
      ...data,
    }));
    setShowExtendedTrialModal(true);
  };

  if (!productKey) {
    return null;
  }

  return (
    <div className="card product-card">
      <div className="product-card-header">
        <div className="product-card-title">
          {/* <img
            src={`https://ui-avatars.com/api/?name=${getProductNameForImage()}&color=ffffff&size=40&background=006efa`}
          /> */}
          <h5 className="card-title">{productName ? productName : "NA"}</h5>
        </div>
        <span
          style={{
            color:
              product.account_status == "Lead"
                ? "#0063e1"
                : product.account_status == "Customer"
                  ? "#28A745"
                  : product.account_status == "Demo"
                    ? "#ffc107"
                    : product.account_status == "Cancelled" ||
                      product.account_status == "Deleted"
                      ? "#ff0000"
                      : "#0063e1",
            backgroundColor:
              product.account_status == "Lead"
                ? "#0063e130"
                : product.account_status == "Customer"
                  ? "#28A74530"
                  : product.account_status == "Demo"
                    ? "#ffc10730"
                    : product.account_status == "Cancelled" ||
                      product.account_status == "Deleted"
                      ? "#ff000030"
                      : "#0063e130",
          }}
        >
          {
            // product.account_status == "Lead" &&
            // billingDetails.is_demo_account === true
            // ? `${billingDetails.account_status} (Demo)`
            // :
            product.account_status || "NA"
          }
        </span>
      </div>
      {/* <div className="product-card-row">
        <div>Joined On</div>
        <div>
          {
            product.account_status === "Cancelled"
              ? (billingDetails.created_date
                ? getFormattedDate(
                  billingDetails.created_date,
                  "MMM, dd yyyy"
                )
                : startDate)
              : startDate
          }
        </div>
      </div> */}
      {product.account_status == "Customer" && (
        <React.Fragment>
          {/* <div className="product-card-row">
            <div>Converted On</div>
            <div>
              {billingDetails.first_subscription_date
                ? getFormattedDate(
                    billingDetails.first_subscription_date,
                    "MMM, dd yyyy"
                  )
                : "NA"}
            </div>
          </div> */}
          {!ismuvi5 &&
            <div className="product-card-row">
              <div>Renewal On</div>
              <div className="text-danger">{endDate}</div>
            </div>
          }
          <div className="product-card-row">
            <div>Plan</div>
            <div>
              {product.plan_name && product.plan_name}

              {product.plan_duration && product.plan_duration
                ? `(${product.plan_duration})`
                : ""}

            </div>
          </div>

          {
            // (product.product_name === "Muvi One" || product.product_name === "Muvi One (Classic)") &&
            Array.isArray(product.applications) &&
            product.applications.length > 0 && (
              <div className="product-card-row">
                <div>Applications</div>

                <div>
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        {product.applications.join(", ")}
                      </Tooltip>
                    }
                  >
                    <span>
                      {product.applications.join(", ").slice(0, 15)}
                      {product.applications.join(", ").length > 15 && " ..."}
                    </span>
                  </Whisper>
                </div>
              </div>
            )}

        </React.Fragment>
      )}
      {product.account_status == "Lead" && !ismuvi5 && (
        <React.Fragment>
          <div className="product-card-row">
            <div>Free Trial Expires On</div>
            <div className="text-danger">{endDate}</div>
          </div>
          <div className="product-card-row">
            <div>Extend Free Trial</div>
            <div className="">
              <button
                style={{
                  border: "none",
                  background: "transparent",
                }}
                onClick={() => handleExtendedFreeTrialClick(product)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                >
                  <g clip-path="url(#clip0_501_8376)">
                    <path
                      d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                      stroke="#373945"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_501_8376">
                      <rect width="12" height="12" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
          <div
            className="convert-demo-card"
           
          >
            <div className="product-card-row">
              <div>Move to Demo</div>

              <button
                style={{
                  border: "none",
                  background: "transparent",
                }}
                 onClick={() => handleAccountSwitch(product.product_key, true)}
              >
                <PiUserSwitch size={16} />
              </button>
            </div>
          </div>
        </React.Fragment>
      )}
      {product.account_status == "Demo" && !ismuvi5 && (
        <React.Fragment>
          <div
            className="convert-demo-card"
            
          >
            <div className="product-card-row">
              <div>Move to Lead</div>

              <button
                style={{
                  border: "none",
                  background: "transparent",
                }}
                onClick={() => handleAccountSwitch(product.product_key, false)}
              >
                <PiUserSwitch size={16} />
              </button>
            </div>
          </div>
        </React.Fragment>
      )}
      {billingDetails.account_status == "Cancelled" && (
        <React.Fragment>
          <div className="product-card-row">
            <div>Cancelled On</div>
            <div className="text-danger">
              {billingDetails.cancellation && billingDetails.cancellation.date
                ? getFormattedDate(
                  billingDetails.cancellation.date,
                  "MMM, dd yyyy"
                )
                : "NA"}
            </div>
          </div>
          <div className="product-card-row">
            <div>Reason</div>
            <div>
              <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        {(billingDetails.cancellation &&
                billingDetails.cancellation.reason ) || "NA"}
                      </Tooltip>
                    }
                  >
                    <span>
                      {/* {product.applications.join(", ").slice(0, 15)}
                      {product.applications.join(", ").length > 15 && " ..."} */}
                      {
                        (billingDetails.cancellation &&
                billingDetails.cancellation.reason &&
                billingDetails.cancellation.reason.length > 20
                ? billingDetails.cancellation.reason.substring(0, 20) + "..."
                : billingDetails.cancellation.reason) || "NA"
                      }
                    </span>
                  </Whisper>
              {}
            </div>
          </div>
        </React.Fragment>
      )}
      {/* TODO: Check Deleted Date */}
      {billingDetails.account_status == "Deleted" && (
        <div className="product-card-row">
          <div className="text-danger">Deleted On</div>
          <div>
            {billingDetails.deleted_date
              ? getFormattedDate(billingDetails.deleted_date, "MMM, dd yyyy")
              : "NA"}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ProductModal.js